import request, { download } from '@/utils/request'

// 查询课程目录列表
export function getSubjectList (query) {
  return request({
    url: `/system/subject/list`,
    method: 'get',
    params: query
  })
}
//修改
export function editSubject (query) {
  return request({
    url: `/system/subject`,
    method: 'put',
    data: query
  })
}

//新增
export function addSubject (query) {
  return request({
    url: `/system/subject`,
    method: 'post',
    data: query
  })
}
export function getProjectTypeListApi () {
  return request({
    url: `/system/project/item/list`,
    method: 'get',
  })
}

export function getProjectListApi (params) {
  return request({
    url: `/system/project/list/no/permission`,
    method: 'get',
    params: params
  })
}
//详情
export function getDetail (id) {
  return request({
    url: `/system/subject/${id}`,
    method: 'get',
  })
}
//导出
export function subjectExport (query) {
  return download(`/system/subject/export`, { ...query }, `课程菜单_${new Date().getTime()}.xlsx`)
}
//修改启用状态
export function changeStatus (params) {
  return request({
    url: `/system/subject/changeStatus`,
    method: 'get',
    params: params
  })
}
//查询课程列表
export function getProjectList () {
  return request({
    url: `/system/subject/getProjectList`,
    method: 'get',
  })
}

//获取关联产品列表
export function getRelatedProductList (data) {
  return request({
    url: `/system/subject/getRelatedProductList`,
    method: 'post',
    data
  })
}

//获取关联产品列表
export function priceAdjustmentApprove (data) {
  return request({
    url: `/system/subject/priceAdjustmentApprove`,
    method: 'post',
    data
  })
}

//改价历史
export function getPriceAdjustmentList (data) {
  return request({
    url: `/system/subject/getPriceAdjustmentList`,
    method: 'post',
    data
  })
}

//获取价格执行列表
export function getDoPriceAdjustmentList (data, params) {
  return request({
    url: `/system/subject/getDoPriceAdjustmentList`,
    method: 'post',
    data,
    params
  })
}

//价格执行所有
export function strikePriceAll (data) {
  return request({
    url: `/system/subject/strikePriceAll`,
    method: 'post',
    data,
    showLoading: true
  })
}

//价格执行单个
export function strikePriceOne (data) {
  return request({
    url: `/system/subject/strikePriceOne`,
    method: 'post',
    data
  })
}


//影响订单明细列表
export function getEffectOrderList (data, params) {
  return request({
    url: `/system/subject/getEffectOrderList`,
    method: 'post',
    headers: { repeatSubmit: false },
    data,
    params
  })
}


//获取课程的关联课程数据
export function getRelatedSubjectById (id) {
  return request({
    url: `/system/subject/getRelatedSubject?subjectId=${id}`,
    method: 'get',
    headers: { repeatSubmit: false }
  })

}

//发起关联课程审批
export function launchRelatedSubject (data) {
  return request({
    url: '/workflow/subject/relate/launchApproval',
    method: 'post',
    headers: { repeatSubmit: false },
    data
  })
}


//查看课程已审批通过的关联课程审批历史
export function getRelatedSubjectHistoryBySubjectId (id) {
  return request({
    url: `/workflow/subject/relate/history/approval?subjectId=${id}`,
    method: 'get',
    headers: { repeatSubmit: false }
  })
}


//设置课程分类
export function setClassification (params) {
  return request({
    url: `/system/subject/setClassification?subjectId=${params.id}&classification=${params.classification}`,
    method: 'get'
  })
}


//课程交付复制
export function copySubject (data) {
  return request({
    url: '/system/subject/copySubject',
    method: 'post',
    data
  })
}


//获取薪酬分类
export function getSalaryCategoryList(){
  return request({
    url:'/system/subject/salaryCategory',
    method:'get',
  })
}

// 查询课程目录列表-支持多个project
export function getSubjectListByProjects (data) {
  return request({
    url: `/system/subject/selectList`,
    method: 'post',
    data
  })
}